import { AssetSvg } from '@/components/foundation/Svg'
import { useTranslator } from '@/hooks/useTranslator'
import { getArea } from '@/stores/areas'
import { useSelector } from '@/stores/hooks'
import { getPoi } from '@/stores/pois'
import { getStop } from '@/stores/stops'
import { type PopupInfo } from '@/stores/temp'
import type { Stop } from '@common/types/Stop'
import styles from './PopupTitleDefault.scss'

export function PopupTitleDefault({ id, type }: PopupInfo) {
	const translator = useTranslator()

	const popupInfo = useSelector(state => {
		if (type === 'stop_point') return getStop(state, id)
		if (type === 'stop_area') return getArea(state, id)
		if (type === 'poi') return getPoi(state, id)
		return null
	})

	const isStopWithPmrAccess =
		type === 'stop_point' && (popupInfo as Stop)?.wheelchair === true

	return (
		<div className={styles.titleContainer}>
			{popupInfo?.name}
			{isStopWithPmrAccess && (
				<AssetSvg
					name="assets/PMR.svg"
					ariaLabel={translator.translate('stop:pmr-available')}
					ariaHidden={false}
					className={styles.iconPmr}
				/>
			)}
		</div>
	)
}
